/* Dependencies */
import { createContext } from 'react';

export const PageContext = createContext({
  pageTitle: '',
});

PageContext.displayName = 'PageContext';
